export const CATEGORY = 'Spiltype';